import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

function Seo({
  description,
  lang,
  meta,
  keywords,
  title,
  isBlogPage,
  structuredData,
}) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description;
          
        // Create links array for RSS feed links
        const links = [];
        
        // Add RSS feed link if it's a blog page or we specifically want to include it
        if (isBlogPage) {
          links.push({
            rel: 'alternate',
            type: 'application/rss+xml',
            title: `${data.site.siteMetadata.title} - RSS Feed`,
            href: `${data.site.siteMetadata.siteUrl}/rss.xml`,
          });
        }
          
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
            link={links}
          >
            {structuredData.map((item, index) => (
              <script
                key={`structured-data-${index}`}
                type="application/ld+json"
              >
                {JSON.stringify(item)}
              </script>
            ))}
          </Helmet>
        );
      }}
    />
  );
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  isBlogPage: false,
  structuredData: [],
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  isBlogPage: PropTypes.bool,
  structuredData: PropTypes.arrayOf(PropTypes.object),
};

export default Seo;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
  }
`;
